// Angular
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

// Libraries
import { Observable, takeUntil } from 'rxjs';
import { Select } from '@ngxs/store';

// Store
import { AuthState } from '../../modules/auth/state/auth.state';
import { UserAuthState } from '../../modules/auth/state/user-auth.state';

// Models
import { AppCleanup, UserModel } from '../models';

@Injectable()
export class AuthGuard extends AppCleanup {
	@Select(AuthState.isLoggedIn) isLoggedIn$: Observable<boolean>;
	@Select(UserAuthState.currentUser) currentUser$: Observable<UserModel>;

	constructor(private router: Router) {
		super();
	}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.loggedIn();
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return this.loggedIn();
	}

	private loggedIn(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		return new Observable((obs) => {
			if (this.isViewer) {
				obs.next(true);
			}

			return this.isLoggedIn$.pipe(takeUntil(this.destroy)).subscribe((loggedIn) => {
				if (!loggedIn && !this.isViewer) {
					this.router.navigate(['/auth/login']); // Redirecting to login page if user is not logged in
					obs.next(false);
				}

				return this.currentUser$.pipe(takeUntil(this.destroy)).subscribe((currentUser) => {
					if (currentUser && !currentUser.confirmedEula && !this.isViewer) {
						this.router.navigate(['/eula']);
						obs.next(false);
					} else {
						obs.next(true);
					}
				});
			});
		});
	}
}
